"use strict";
/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = exports.IndustrialCapability = void 0;
/**
 * Capacité industrielle d'un site de stockage.
 * - milling: Capacité de broyage/mouture (ON/OFF Milling pour CMG)
 */
var IndustrialCapability;
(function (IndustrialCapability) {
    IndustrialCapability["Milling"] = "milling";
})(IndustrialCapability || (exports.IndustrialCapability = IndustrialCapability = {}));
/**
 * Nom de la permission vérifiée
 * @example "counter_sale:execute"
 */
var Permission;
(function (Permission) {
    Permission["CounterSaleExecute"] = "counter_sale:execute";
    Permission["PaymentValidationBypassAll"] = "payment_validation:bypass_all";
    Permission["CustomersManageAll"] = "customers:manage_all";
})(Permission || (exports.Permission = Permission = {}));
